const RESIZE_OBSERVER_MSG =
  'ResizeObserver loop completed with undelivered notifications.'

let registered = false

export function suppressResizeObserverError(): void {
  if (registered) return
  registered = true

  window.addEventListener('error', (e: ErrorEvent) => {
    if (e.message === RESIZE_OBSERVER_MSG) {
      const overlay = document.getElementById(
        'webpack-dev-server-client-overlay',
      )
      const overlayDiv = document.getElementById(
        'webpack-dev-server-client-overlay-div',
      )
      if (overlay) overlay.setAttribute('style', 'display: none')
      if (overlayDiv) overlayDiv.setAttribute('style', 'display: none')
    }
  })
}
